import React from 'react';
import { useUserQuestions } from '../../../../../../../../data/hooks/questions/useUserQuestions';
import { useMyUserId } from '../../../../../../../../data/hooks/sessionHooks';
import useAnimatedVisibility from '../../../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';
import Icon from '../../../../../../../elements/icons/Icon';
import styles from '../border-icons.module.scss';

const QuestCircleIcon = props => {
    const {className = '', event, user, hide = false} = props,
        selfId = useMyUserId(),
        isMe = user.user_id == selfId,
        questions = useUserQuestions(event.id, user.user_id).sort((q1, q2) => q2.lastUpdateTimestamp - q1.lastUpdateTimestamp),
        {mounted, visible, onTransitionEnd} = useAnimatedVisibility({
            visible: !isMe && !hide && questions.length,
            timeout: 1000,
        });

    if (!mounted) return null;

    return (
        <Icon
            className={[className, visible ? styles.visible : styles.hidden].join(' ')}
            color="white"
            src="/img/quests-icon.png"
            onTransitionEnd={onTransitionEnd}
        />
    );
};

export default QuestCircleIcon;
